import api from '@/core/api/client';

export interface AiSettingsData {
  id: number;
  /** Provedor para transcrição de voz: azure | openai | groq */
  defaultTranscriptionProvider: string;
  azureKey: string | null;
  /** Endpoint do Azure AI Services, ex.: https://as-orya-dev.cognitiveservices.azure.com/ */
  azureEndpoint: string | null;
  /** Usado somente quando azureEndpoint não for preenchido */
  azureRegion: string | null;
  openaiApiKey: string | null;
  groqApiKey: string | null;
  /** Deployment para tarefas simples/baratas (ex: gpt-4o-mini) */
  lowTierDeployment: string | null;
  /** Deployment para tarefas complexas/premium (ex: gpt-4o) */
  highTierDeployment: string | null;
  updatedAt: string;
}

export const aiSettingsService = {
  async get(): Promise<AiSettingsData> {
    const res = await api.get('/configuracoes/ai');
    return res.data;
  },

  async update(data: Partial<AiSettingsData>): Promise<AiSettingsData> {
    const res = await api.patch('/configuracoes/ai', data);
    return res.data;
  },
};
